import types from "../actionTypes";
import setLoaderAction from "./loaderAction";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import { isSessionValid } from "./profileAction";
import { DEFAULT_ERROR_MESSAGE, ERROR_TIMEOUT } from "../../App.config";

/************************************ ACTIONS ****************************************/

function setFilterApplicationValue(value) {
  return {
    type: types.SET_FILTER_APPLICATION_VALUES,
    value,
  };
}

/************************************ ACTION CREATORS ****************************************/

//Setting form step count

export const resetFilterApplication = () => (dispatch) => {
  dispatch(setFilterApplicationValue([]));
};


export const setFilterApplication = (searchKey, profilereducer) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getEmployeeByFilter(searchKey, profilereducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setFilterApplicationValue(data.lstEmployee));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

